import * as React from 'react';
import { IconsTransport } from 'shared/components/SimilarOffersRedesigned/icons/IconsTransport';
import { ETransportType } from 'shared/store/similar';
import { IUndergroundSchema } from 'shared/types/recommendedOffer';

import * as styles from './Underground.css';
import { IconsMetro } from '../IconsMetro';

interface IUndergroundProps {
  underground: IUndergroundSchema;
}

export const Underground: React.FC<IUndergroundProps> = ({
  underground: { time, transportType, color, icon, name },
}) => {
  return (
    <div className={styles['container']}>
      <div style={{ color: `#${color}` }} className={styles['name']}>
        <IconsMetro type={icon} />
        <span className={styles['ellipsis']}>{name}</span>
      </div>
      {time && transportType && (
        <div className={styles['transport']}>
          <IconsTransport type={transportType as ETransportType} />
          <span>{time} мин</span>
        </div>
      )}
    </div>
  );
};
